import axios from 'axios'

export default {
    getConfig: () => {
        return new Promise((resolve, reject) => {
            axios.get('/config.json').then(response => {
                resolve(response.data)
            })
        })
    },

    setFont: (font) => {
        const textFontLink = document.createElement('link')
        textFontLink.setAttribute('rel', 'stylesheet')
        textFontLink.href = font.textFont.url
        document.head.appendChild(textFontLink)
        document.documentElement.style.setProperty('--text-font', font.textFont.name)
        
        if(font.titleFont.name !== font.textFont.name){
            const titleFontLink = document.createElement('link')
            titleFontLink.setAttribute('rel', 'stylesheet')
            titleFontLink.href = font.titleFont.url
            document.head.appendChild(titleFontLink)
        }
        document.documentElement.style.setProperty('--title-font', font.titleFont.name)
    },

    setColors: (colors) => {
        document.documentElement.style.setProperty('--primary', colors.primary)
        document.documentElement.style.setProperty('--secondary', colors.secondary)
        document.documentElement.style.setProperty('--text-color', colors.text)
        document.documentElement.style.setProperty('--text-color-light', colors.textLight)
        document.documentElement.style.setProperty('--background', colors.background)
        document.documentElement.style.setProperty('--background-dark', colors.backgroundDark)
    },
}